import React from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { CommonDrawerProps } from '../types/common.types';

const CommonDrawer: React.FC<CommonDrawerProps> = ({
  open,
  title,
  onClose,
  children,
  anchor = 'right',
  width = 420,
  actions,
}) => {
  return (
    <Drawer anchor={anchor} open={open} onClose={onClose}>
      <Stack sx={{ width, maxWidth: '100vw', height: '100%' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e2eef1' }}
        >
          <Typography variant="h6" fontWeight={700}>{title}</Typography>
          <IconButton onClick={onClose} aria-label="close drawer">
            <CloseRoundedIcon />
          </IconButton>
        </Stack>

        <Box sx={{ p: 2, flexGrow: 1, overflowY: 'auto' }}>{children}</Box>

        {actions ? (
          <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ p: 2, borderTop: '1px solid #e2eef1' }}>
            {actions}
          </Stack>
        ) : null}
      </Stack>
    </Drawer>
  );
};

export default CommonDrawer;
